import config from "./config.json";
const { DESKTOP_APP, DESKTOP_APP_HOSTNAME } = config;

export const COMPANY_NAME = "Software Studio Pro";
export const COMPANY_DOMAIN = "https://www.softwarestudiopro.com";
export const COMPANY_EMAIL = "softwarestudiopro@gmail.com";
export const COMPANY_ADDRESS = `We are a remote company and expanding our firm over the world. You can contact us at ${COMPANY_EMAIL}`;
export const COMPANY_NUMBER = "+91 7903556574";
export const COMPANY_INSTAGRAM = "https://www.instagram.com/softwarestudiopro/";
export const COMPANY_DISCORD = "https://discord.gg/CApcRwtr";
export const COMPANY_YOUTUBE = "https://www.youtube.com/@softwarestudiopro";
export const COMPANY_LINKEDIN = "https://www.linkedin.com/company/software-studio-pro";

const getHostname = () => {
  if (typeof window !== "undefined") {
    return window.location.hostname;
  }
  return "localhost";
};

export const HOSTNAME = DESKTOP_APP ? DESKTOP_APP_HOSTNAME : getHostname();
